import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
interface InputProps {
  label: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  required?: boolean;
  placement: string;
}
const TeaxtArea: React.FC<InputProps> = ({
  label,
  register,
  required,
  error,
  placement,
}) => {
  return (
    <div className="form-group mb-4 sm:mb-0">
      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
        {label}
        {required && <span className="font-[400]"> (Required)</span>}
      </label>
      <div className="relative">
        <textarea
          {...register}
          placeholder={placement}
          rows={3}
          className=" border mt-1 p-2 rounded w-full"
        ></textarea>
        {error && <span className="text-[#B91C1C]">{error.message}</span>}
      </div>
    </div>
  );
};

export default TeaxtArea;
